import script from "./tag-folder.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-folder.vue?vue&type=script&setup=true&lang=js"

import "./tag-folder.vue?vue&type=style&index=0&id=90c4f30c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90c4f30c"]])

export default __exports__